import * as Accordion from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export const AccordionRoot = (props: {
  children: React.ReactNode;
  className?: string;
  defaultValue?: string[];
  value?: string[];
  setValue?: (value: string[]) => void;
  type?: "single" | "multiple";
}) => {
  const { children, className, defaultValue, type, setValue, value } = props;

  if (type === "single") {
    return (
      <Accordion.Root
        type="single"
        defaultValue={
          defaultValue && defaultValue.length > 0 ? defaultValue[0] : undefined
        }
        value={value && value.length > 0 ? value[0] : undefined}
        onValueChange={(value) => {
          if (setValue) {
            setValue([value]);
          }
        }}
        className={`accordion ${className ?? ""}`}
        collapsible
      >
        {children}
      </Accordion.Root>
    );
  }
  return (
    <Accordion.Root
      type={"multiple"}
      defaultValue={defaultValue}
      className={`accordion ${className ?? ""}`}
      value={value}
      onValueChange={(value) => {
        if (setValue) {
          setValue(value);
        }
      }}
    >
      {children}
    </Accordion.Root>
  );
};

export const AccordionItem = (props: {
  children: React.ReactNode;
  className?: string;
  value: string;
}) => {
  const { children, className, value } = props;
  return (
    <Accordion.Item
      className={`accordion-item ${className ?? ""}`}
      value={value}
    >
      {children}
    </Accordion.Item>
  );
};

interface IAccordionHeaderProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  sectionStarted?: boolean;
  sectionComplete?: boolean;
}
export const AccordionHeader = forwardRef<
  HTMLHeadingElement,
  IAccordionHeaderProps
>(
  (
    {
      children,
      className,
      onClick,
      sectionComplete,
      sectionStarted,
    }: IAccordionHeaderProps,
    ref,
  ) => {
    return (
      <Accordion.Header
        className={`accordion-header ${className ?? ""}`}
        ref={ref}
      >
        <Accordion.Trigger
          className={`accordion-button collapsed`}
          onClick={onClick}
        >
          <span className="d-flex align-items-center gap-3 w-100 pe-3">
            {children}
            {sectionStarted === false && (
              <span className="badge badge-light ms-auto">Ikke påbegyndt</span>
            )}
            {sectionStarted === true && sectionComplete === false && (
              <span className="badge badge-danger ms-auto">Ikke færdig</span>
            )}
          </span>
        </Accordion.Trigger>
      </Accordion.Header>
    );
  },
);

export const AccordionBody = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <Accordion.Content className="accordion-collapse">
      <div className={`accordion-body ${className ?? ""}`}>{children}</div>
    </Accordion.Content>
  );
};
